import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
//Avoids tree shaking by webpack
gsap.registerPlugin(ScrollTrigger);
const ribbonScrollAnimation = (anim) => {
    return ScrollTrigger.create({
        trigger: "#main-content",
        start: "top top",
        end: "bottom 50%+=100px",
        // markers: true,
        animation: anim,
        // scrub: 0.1,
        toggleActions: "play play reverse reverse",
    });
};
document.addEventListener("DOMContentLoaded", () => {
    const eventRibbonElement = document.querySelector('.event-ribbon');
    if (eventRibbonElement) {
        //Matching the bootstrap breakpoint of below xl
        const mql = window.matchMedia('screen and (max-width: 1200px)');
        let eventRibbonHeight = '80px';
        //Get the animation setup on first load for mobile devices
        if (mql.matches) {
            eventRibbonHeight = '80px';
        }
        else {
            eventRibbonHeight = '80px'; //earlier was 120px, not removing code as it might change
        }
        gsap.set('body', { "--event-ribbon-height": eventRibbonHeight });
        //Changing the CSS variable set on body, so both ribbon and spacing of header-mobile are animated
        const anim = gsap.to('body', { "--event-ribbon-height": "0", immediateRender: false });
        let scollAnim = ribbonScrollAnimation(anim);
        //Run the animation on change of window size
        mql.addEventListener('change', () => {
            scollAnim.kill();
            if (mql.matches) {
                eventRibbonHeight = '80px';
            }
            else {
                eventRibbonHeight = '80px';
            }
            gsap.set('body', { "--event-ribbon-height": eventRibbonHeight });
            //Changing the CSS variable set on body, so both ribbon and spacing of header-mobile are animated
            const anim = gsap.to('body', { "--event-ribbon-height": "0", immediateRender: false });
            scollAnim = ribbonScrollAnimation(anim);
        });
    }
    else {
        gsap.set('body', { "--event-ribbon-height": '0px' });
    }
});
